import { render, staticRenderFns } from "./MetaCompetitors.vue?vue&type=template&id=bb2235ae&scoped=true&"
import script from "./MetaCompetitors.vue?vue&type=script&lang=ts&"
export * from "./MetaCompetitors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2235ae",
  null
  
)

export default component.exports